<template>
  <v-dialog :value="open" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        {{userName}}さんの入社予定日をご入力ください。
      </v-card-title>
      <div class="mx-auto mt-4" style="width:200px">
        <DateField
            v-model="joinSchedule"
            placeholder="入社予定日"
        />
      </div>
      <v-card-text style="padding-bottom: 4px">
        本操作による候補者への通知はされません。<br/>
        入社決定後、候補者のステータスは変更できなくなります。
      </v-card-text>
      <v-row class="pb-2">
        <v-col cols="6" class="text-center">
          <v-btn
              rounded
              width="100"
              color="primary"
              :disabled="saveDisabled"
              @click="submit"
          >保存</v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
          <v-btn
              rounded
              outlined
              width="100"
              color="error"
              @click="cancel"
          >キャンセル</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import DateField from "@/components/atoms/DateField";
import ApiMixin from "@/ApiMixin";
export default {
  mixins: [ApiMixin],
  name: "JoinDateFormDialog",
  components: {DateField},

  props: {
    open: {
      type: Boolean
    },
    userName: {
      type: String
    },
    jobId: {
      type: String
    },
    candidateId: {
      type: String
    },
    status: {
      type: Number
    }
  },
  data() {
    return {
      joinSchedule: null,
    }
  },
  computed: {
    saveDisabled() {
      return this.joinSchedule == null
    }
  },
  methods: {
    submit () {
      this.submitJoinSchedule(this.jobId, this.candidateId, this.status, this.joinSchedule).finally(() => {
        this.saveButtonDisabled = false
        this.$emit("complete")
      })
      this.joinSchedule = null
    },
    cancel () {
      this.$emit("cancel")
      this.joinSchedule = null
    }
  }
}
</script>

<style scoped>

</style>